module.exports = __webpack_public_path__ + "static/green-arrow-41a70aa126e3c55d1ce0ce365d36e37c.webp";